const Targeting = {
  ENTERPRISE: 'zorse-chatflow-targeting-enterprise',
  PRO: 'zorse-chatflow-targeting-pro',
  STARTER: 'zorse-chatflow-targeting-starter'
};
export const getProductTier = (scopes = []) => {
  let highestTier;
  for (const scope of scopes) {
    switch (scope) {
      case Targeting.ENTERPRISE:
        return 'enterprise';
      case Targeting.PRO:
        highestTier = 'pro';
        break;
      case Targeting.STARTER:
        highestTier = highestTier === 'pro' ? 'pro' : 'starter';
        break;
      default:
        break;
    }
  }
  if (!highestTier && !scopes.includes('zorse-webticket')) {
    return 'free';
  }
  return highestTier;
};